import { RecordContextProvider, useListContext, useTranslate } from "ra-core";

import { ListSkeleton } from "../misc/ListSkeleton";
import type { Company } from "../types";
import { CompanyCard } from "./CompanyCard";

const LoadedGridList = () => {
  const { data, error, isPending } = useListContext<Company>();
  const translate = useTranslate();

  if (isPending || error) return null;

  return (
    <div
      className="w-full gap-2 grid"
      style={{
        gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
      }}
    >
      {data.map((record) => (
        <RecordContextProvider key={record.id} value={record}>
          <CompanyCard />
        </RecordContextProvider>
      ))}

      {data.length === 0 && (
        <div className="p-2">
          {translate("resources.companies.empty.title", {
            _: "No companies found",
          })}
        </div>
      )}
    </div>
  );
};

export const ImageList = () => {
  const { isPending } = useListContext();
  return isPending ? (
    <ListSkeleton variant="grid" rows={12} />
  ) : (
    <LoadedGridList />
  );
};
